import React, { useContext } from "react";
import FilterBar from "./FilterBar";
import UserContext from "contexts/UserContext";

//exported for use in /articles/topics/[topic].js
export const publicationsFilterLinks = [
	{ name: "Latest", link: "/articles" },
	{ name: "Topics", link: "/articles/topics" },
	// { name: "Wellness Topics", link: "#" },
	{ name: "SoundPractice Podcast", link: "https://www.soundpractice.com/", isExternal: true },
	{ name: "Contribute", link: "/publications/contribute" },
];

export default function LibraryFilterBar() {
	const { user } = useContext(UserContext);

	return (
		<FilterBar
			filterButtons={publicationsFilterLinks}
			withBookmark={user ? "/bookmarks" : false} //TODO commented out bookmarking feature
			withSearch={true}
		/>
	);
}
